import {
  MenuItemLink,
  MenuItemLinkProps,
} from 'layouts/components/Menu/components/MenuItemLink/MenuItemLink';

import { useGetCounter } from './hooks/useGetCounter';
import { StyledBadge } from './MenuItemLinkWithCounter.styled';

type Props = {
  counter: string;
} & MenuItemLinkProps;

export const MenuItemLinkWithCounter: React.FC<Props> = ({
  counter,
  primaryText,
  ...restProps
}) => {
  const { data, isLoading } = useGetCounter(counter);

  return (
    <MenuItemLink {...restProps}>
      <StyledBadge badgeContent={data?.count} color="error" invisible={!data?.count && isLoading}>
        {primaryText}
      </StyledBadge>
    </MenuItemLink>
  );
};
